export const DEFAULT_ADMIN_NAMESPACE = 'admin'
export const DEPRECATED_ADMIN_PATH_ALIAS_SUFFIXES = ['/data/*', '/auth', '/auth/middleware']
export const BETTERSTART_ASSET_HOST = 'assets.betterstart.dev'
export const LEGACY_DEFAULT_AUTH_URL = 'http://localhost:3000'
export const DATABASE_URL_PLACEHOLDER = 'postgresql://...'
export const DEFAULT_DEV_PORT = 4242
export const MAIN_CSS_CANDIDATES = [
  'src/app/globals.css',
  'app/globals.css',
  'src/app/global.css',
  'app/global.css',
  'src/app/app.css',
  'app/app.css',
  'src/globals.css',
  'globals.css'
]
export const CONFIG_IMPORT_SHIM = 'const defineConfig = <T>(config: T): T => config'
export const TIPTAP_CONTENT_EDITOR_DIRECTORIES = ['tiptap-extension', 'tiptap-node', 'tiptap-ui']
export const RAILWAY_BUCKET_ENV_KEYS = [
  'BETTERSTART_RAILWAY_BUCKET_ENDPOINT',
  'BETTERSTART_RAILWAY_BUCKET_ACCESS_KEY_ID',
  'BETTERSTART_RAILWAY_BUCKET_SECRET_ACCESS_KEY',
  'BETTERSTART_RAILWAY_BUCKET_NAME',
  'BETTERSTART_RAILWAY_BUCKET_REGION',
  'BETTERSTART_RAILWAY_BUCKET_URL_STYLE'
] as const
export const R2_ENV_KEYS = [
  'BETTERSTART_R2_ACCOUNT_ID',
  'BETTERSTART_R2_ACCESS_KEY_ID',
  'BETTERSTART_R2_SECRET_ACCESS_KEY',
  'BETTERSTART_R2_BUCKET_NAME',
  'BETTERSTART_R2_PUBLIC_URL'
] as const
